import { StepBadgeCircle } from './StepBadge.styles';

export const StepBadge = ({ number }: { number: number }) => (
  <StepBadgeCircle aria-hidden>{number}</StepBadgeCircle>
);
